<template>
  <PageContentLayoutOnly role="region" vendor-details>
    <section class="section card" v-if="vendor">
      <div class="level pl-5 pr-5" :style="{ display: 'flex' }">
        <div class="pt-5 level-left level-item title">{{ $t('vendors.detailsTitle') }}</div>
        <div class="level-right" :style="{ display: 'flex' }">
          <svg
            width="30"
            height="30"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            ></path>
          </svg>
          <b-button label="Back to Vendors" @click.prevent="returnToParent()" />
        </div>
      </div>

      <div
        v-if="
          vendor.remittanceVendorGlobalAddress &&
            vendor.remittanceVendorGlobalAddress != undefined &&
            vendor.remittanceVendorGlobalAddress.address &&
            vendor.remittanceVendorGlobalAddress.address != undefined
        "
      >
        <Address :address="vendor.remittanceVendorGlobalAddress.address" />
      </div>

      <LinksMenu
        aria-label="vendor details tabs"
        :tabs="tabs"
        prefix="vendor."
        :style="{
          paddingLeft: '20px'
        }"
        :params="{
          id: $route.params.id
        }"
      >
        <section :style="{ overflowX: 'auto', flexGrow: 2 }">
          <SlideTransition :name="transitionName">
            <keep-alive>
              <router-view :key="$route.name" />
            </keep-alive>
          </SlideTransition>
        </section>
      </LinksMenu>

      <!-- tabbable sections -->
      <!--       <div id="tabs">
        <div class="card-content columns" :style="styles.mainContainer">
          <div class="column is-2">
            <DetailsMenu
              aria-label="vendor details tabs"
              :tabs="tabs"
              prefix="vendor."
              :params="{
                id: $route.params.id
              }"
            />
          </div>

          <div class="column is-10" style="overflow: hidden; position: relative">
            <SlideTransition :name="transitionName">
              <router-view />
            </SlideTransition>
          </div>
        </div>
      </div> -->
    </section>
  </PageContentLayoutOnly>
</template>

<script>
import _get from 'lodash/get'
import { mapState } from 'vuex'
import SlideTransition from '@/components/transitions/Slide.vue'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import Address from './components/Address'
//import ContactDetails from './components/ContactDetails'

import { data } from './keys/data'
import { methods } from './keys/methods'
import { watch } from './keys/watch'

import LinksMenu from '@/components/menus/Links'

export default {
  components: {
    Address,
    SlideTransition,
    PageContentLayoutOnly,
    LinksMenu
  },

  data,

  computed: {
    ...mapState({
      unit: state => state.hoa.unit
    }),

    ownerID() {
      return _get(this, ['unit', 'primaryOwner', 'ownerID'], null)
    },

    debug() {
      return this.unit
    },

    lotNumber() {
      return _get(this, ['unit', 'lotNumber'], null)
    },

    primaryContact() {
      return _get(this, ['unit', 'primaryOwner', 'ownerContacts', 0], null)
    }
  },

  watch,

  mounted() {
    this.reload()
  },

  methods,

  i18n: {
    messages: {
      en: { vendors: { detailsTitle: 'Vendor Details' } }
    }
  }
}
</script>

<style lang="scss" scoped>
.owner-avatar {
  margin: 1em auto 2em;
}

.card {
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05) !important;

  .card {
    border: 0 !important;
  }
}

.avatar-img {
  border: 1px solid #e7e8f2;
  padding: 0.25em;
}

.address-card {
  h5,
  h6 {
    margin: 0;
  }
}

.details-img {
  img {
    border-radius: 0.5em;
  }
}
</style>
